



















































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";

@Component({})
export default class BaseMultiSelect extends Vue {
  @Prop() readonly value!: Array<any> | null;
  @Prop({ default: "Seleziona un valore" }) readonly placeholder!: string;
  @Prop({ default: "name" }) readonly label!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly confirmSelection!: boolean;
  @Prop({ default: false }) readonly showDropdown!: boolean;
  @Prop({ type: Boolean, default: false }) readonly searchEnabled!: boolean;
  @Prop({ default: true }) readonly clearItemsOnReselect!: boolean;

  @Ref("searchInput") searchInput!: HTMLInputElement;
  @Ref("scroll") scroll!: HTMLSpanElement;

  dropdownVisible: boolean = this.showDropdown;
  selected = this.value; //FIXME: watcher per fillare con la prop
  search: any = null;

  @Watch("value", { immediate: true })
  onValueUpdated(val: Array<any> | null) {
    this.selected = val;
  }

  @Watch("showDropdown")
  onShowDropdownUpdated(show: boolean) {
    if (!show) {
      this.hideDropdown(); //TODO
    }
  }

  @Watch("search")
  onSearchUpdated(value: string) {
    this.$emit("search", value);
  }

  get containerCssClass() {
    return {
      "multiselect-container": true,
      "multiselect-open": this.dropdownVisible,
      "multiselect-disabled": this.disabled,
    };
  }

  get selectionCssClass() {
    return {
      "multiselect-selection": true,
      "multiselect-empty": this.selected?.length == 0,
      "multiselect-selected": (this.selected?.length ?? 0) > 0,
      "multiselect-open": this.dropdownVisible,
    };
  }

  get result() {
    if (this.selected?.length == 0) {
      return this.placeholder;
    } else {
      return this.selected?.length == 1
        ? "<b>1 elemento</b> selezionato"
        : `<b>${this.selected?.length} elementi</b> selezionati`;
    }
  }

  toggleDropdown() {
    if (this.disabled) {
      return;
    }

    this.dropdownVisible = !this.dropdownVisible;
    this.$emit("toggle-visible", this.dropdownVisible);

    if (this.searchEnabled && this.dropdownVisible) {
      this.$nextTick(() => {
        this.searchInput.focus();
      });
    }
  }

  hideDropdown() {
    if (!this.dropdownVisible) {
      return;
    }

    this.dropdownVisible = false;
    this.$emit("toggle-visible", this.dropdownVisible);
  }

  toggleDropdownOrClearResult() {
    if (this.disabled) {
      return;
    }

    if (this.selected?.length == 0) {
      this.toggleDropdown();
      return;
    }

    if (this.clearItemsOnReselect) {
      this.clearSelection();
    } else {
      this.toggleDropdown();
    }
  }

  clearSelection() {
    this.selected = [];
    this.$emit("input", this.selected);
    this.$emit("cleared");
  }

  selectAll() {
    this.$emit("select-all");
  }

  reset() {
    this.selected = [];
    this.$emit("input", this.selected);
    this.$emit("reset");
  }

  apply() {
    this.$emit("apply");
  }

  onScroll(e: Event) {
    this.$emit("scroll", e, this.scroll);
  }

  clearSearch() {
    this.search = null;
  }
}
